"use client";

import { cn } from "@/lib/utils";
import { useEffect, useState } from 'react';
import { BackToTopPosition } from "@prisma/client";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

type BackToTopButtonProps = {
    enableBackToTopButton: boolean;
    backToTopPosition: BackToTopPosition;
}

function BackToTopButton(props: BackToTopButtonProps) {
    const { enableBackToTopButton, backToTopPosition } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);
    const colorStyle = useContext(ColorStyleContext);

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
    };

    if (!enableBackToTopButton) {
        return null;
    }

    useEffect(() => {
        let scrollTimeout: NodeJS.Timeout;

        const handleScroll = () => {
            setIsScrolling(true); // Set scrolling state to true
            setIsVisible(window.scrollY > 100); // Show button if scrolled more than 100px

            // Clear the previous timeout and set a new one
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                setIsScrolling(false); // Set scrolling state to false after 5 seconds
            }, 5000);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(scrollTimeout); // Clear timeout on cleanup
        };
    }, []);

    return (
        <>
            {isVisible && isScrolling && (
                <div
                    id={`scroll-to-top-btn`}
                    onClick={scrollToTop}
                    className={`fixed bottom-4 ${backToTopPosition === BackToTopPosition.LEFT ? 'left-4' : 'right-4'} 
                        z-[9001] w-12 h-12 flex items-center justify-center rounded-full
                        cursor-pointer transition-all duration-300 ease-in-out
                        dynamic-bg dynamic-color
                    `}
                    style={{
                        "--dynamic-bg": colorStyle?.buttonBgNormal || "#009eca",
                        "--dynamic-hover-bg": colorStyle?.buttonBgHover || "#254b7c",
                        "--dynamic-color": colorStyle?.buttonTextNormal || "#ffffff",
                        "--dynamic-hover-color": colorStyle?.buttonTextHover || "#ffffff",
                        "--dynamic-focus-color": colorStyle?.buttonTextHover || "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.08)"
                    } as React.CSSProperties}
                >
                    <ArrowUpwardIcon 
                        className="w-6 h-auto"
                    />
                </div>
            )}
        </>
    )
}

export default BackToTopButton;
